import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { TicketCategory, useTicketCategory } from '../TicketCategory';
import { ErrorBag, handleFormError } from '@/core/common';
import { fillContentModels } from '@/core/languageContent';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import { getAllLanguages, Language } from '@/modules/parameters/Language';

interface TicketCategoryFormProps {
	pageTitle: string;
	ticketCategory: TicketCategory;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketCategoryForm',
  props: {
    pageTitle: {},
    ticketCategory: {}
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const resource = useTicketCategory();
const languages = ref<Language[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<TicketCategory>>();

// Set data to form on mount and when the prop value changes.
const setData = () => {
	data.value = Object.assign({content: []}, props.ticketCategory);
	data.value.content = fillContentModels(data.value.content || [], languages.value);
};
onMounted(async () => {
	languages.value = await getAllLanguages();
	setData();
});
watch(() => props.ticketCategory, setData);

const save = async () => {
	errors.value = {};

	const postBody: TicketCategory = Object.assign({}, data.value) as TicketCategory;

	let promise: Promise<TicketCategory>;
	if (props.ticketCategory?.id) {
		promise = resource.put(props.ticketCategory.id, postBody);
	} else {
		promise = resource.post(postBody);
	}

	try {
		const response = await promise;

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": __props.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, {
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Avbryt", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Spara", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
        return (_openBlock(), _createElementBlock("div", {
          key: language.id,
          class: "panel"
        }, [
          _createElementVNode("h2", null, _toDisplayString(language.name), 1),
          _createVNode(AppFormGroup, {
            id: `ticket_category_name_${language.id}`,
            errors: errors.value.name,
            label: _unref($gettext)('Namn')
          }, {
            default: _withCtx(() => [
              _createVNode(AppInput, {
                type: "name",
                id: `ticket_category_name_${language.id}`,
                modelValue: data.value.content[language.id].name,
                "onUpdate:modelValue": ($event: any) => ((data.value.content[language.id].name) = $event),
                required: ""
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["id", "errors", "label"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})